import React from "react";

// Reemplazo del alert()/confirm() nativo del navegador — mismo lenguaje
// visual que ConfirmarAprobacionModal/ConfirmarNoActivoModal (icono en
// círculo de color + título + mensaje), para que un aviso no se vea como
// una ventanita cruda del sistema operativo.
const ESTILOS_TIPO = {
  exito: { icono: "✅", bg: "#dcf0e6", color: "#2f7a54" },
  error: { icono: "⚠️", bg: "#f7ded9", color: "#a3402f" },
  info: { icono: "ℹ️", bg: "#d7e8f7", color: "#1d5fa8" },
};

// `contenido` (opcional) va debajo del mensaje — por ejemplo tablas con el
// detalle de lo aprobado; con contenido el modal se ensancha.
function AvisoModal({ tipo = "info", titulo, mensaje, contenido, onCerrar }) {
  if (!mensaje) return null;
  const t = ESTILOS_TIPO[tipo] || ESTILOS_TIPO.info;

  return (
    <div style={styles.overlay} onClick={onCerrar}>
      <div style={{ ...styles.modal, ...(contenido ? { maxWidth: 560 } : {}) }} onClick={(e) => e.stopPropagation()}>
        <div style={styles.encabezado}>
          <div style={{ ...styles.icono, background: t.bg, color: t.color }}>{t.icono}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            {titulo && <h3 style={styles.titulo}>{titulo}</h3>}
            <p style={styles.mensaje}>{mensaje}</p>
          </div>
        </div>
        {contenido}
        <div style={styles.pie}>
          <button type="button" onClick={onCerrar} style={styles.boton} autoFocus>
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(27,42,74,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2100,
    padding: "1rem",
  },
  modal: {
    background: "#fff",
    borderRadius: 16,
    padding: "1.4rem 1.5rem 1.2rem",
    width: "100%",
    maxWidth: 420,
    boxShadow: "0 16px 48px rgba(27,42,74,0.35)",
  },
  encabezado: { display: "flex", gap: "0.85rem", alignItems: "flex-start" },
  icono: {
    width: 44,
    height: 44,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.3rem",
    flexShrink: 0,
  },
  titulo: { margin: "0 0 0.3rem", fontSize: "1.02rem", color: "var(--tema-titulo, #0b3c60)" },
  mensaje: { margin: 0, fontSize: "0.88rem", color: "#3d4a5c", lineHeight: 1.5 },
  pie: { display: "flex", justifyContent: "flex-end", marginTop: "1.3rem" },
  boton: {
    background: "var(--tema-titulo, #0b3c60)",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    padding: "0.55rem 1.3rem",
    fontSize: "0.88rem",
    fontWeight: 700,
    cursor: "pointer",
  },
};

export default AvisoModal;
